import {RelationshipType} from 'graphql-client/__generated/graphqlGlobalTypes';

import {DiagramPixelPoint, VerticalSide} from './diagram-layout/diagramLayoutTypes';

// For (one to _) or (_ to one) relationships (a vertical dash)
const ONE_HEIGHT = 10; // px - height of the vertical dash
const ONE_OFFSET = 8; // px - distance from table edge of the vertical dash

// For (many to _) or (_ to many) relationships (a 3-pronged triangular fork)
const MANY_HEIGHT = 10; // px - max height of the fork
const MANY_JOIN_OFFSET = 10; // px - distance from table edge that the fork lines join

export enum RelationshipDecoratorType {
  MANY = 'many',
  ONE = 'one',
  NONE = 'none',
}

interface RelationshipEndTypes {
  sourceDecoratorType: RelationshipDecoratorType;
  targetDecoratorType: RelationshipDecoratorType;
}

export function getRelationshipDecoratorTypes(relationshipType: RelationshipType): RelationshipEndTypes {
  switch (relationshipType) {
    case RelationshipType.MANY_TO_MANY:
      return {
        sourceDecoratorType: RelationshipDecoratorType.MANY,
        targetDecoratorType: RelationshipDecoratorType.MANY,
      };
    case RelationshipType.MANY_TO_ONE:
      return {
        sourceDecoratorType: RelationshipDecoratorType.MANY,
        targetDecoratorType: RelationshipDecoratorType.ONE,
      };
    case RelationshipType.ONE_TO_MANY:
      return {
        sourceDecoratorType: RelationshipDecoratorType.ONE,
        targetDecoratorType: RelationshipDecoratorType.MANY,
      };
    case RelationshipType.ONE_TO_ONE:
      return {
        sourceDecoratorType: RelationshipDecoratorType.ONE,
        targetDecoratorType: RelationshipDecoratorType.ONE,
      };
    case RelationshipType.UNKNOWN:
    default:
      return {
        sourceDecoratorType: RelationshipDecoratorType.NONE,
        targetDecoratorType: RelationshipDecoratorType.NONE,
      };
  }
}

export function getRelationshipDecoratorPixelPath(
  decoratorType: RelationshipDecoratorType,
  side: VerticalSide,
  originPoint: DiagramPixelPoint
): Array<DiagramPixelPoint> {
  switch (decoratorType) {
    case RelationshipDecoratorType.ONE:
      return [
        {
          x: originPoint.x + (side === VerticalSide.LEFT ? -ONE_OFFSET : ONE_OFFSET),
          y: originPoint.y - ONE_HEIGHT / 2,
        },
        {
          x: originPoint.x + (side === VerticalSide.LEFT ? -ONE_OFFSET : ONE_OFFSET),
          y: originPoint.y + ONE_HEIGHT / 2,
        },
      ];
    case RelationshipDecoratorType.MANY:
      return [
        {x: originPoint.x, y: originPoint.y + MANY_HEIGHT / 2},
        {
          x: originPoint.x + (side === VerticalSide.LEFT ? -MANY_JOIN_OFFSET : MANY_JOIN_OFFSET),
          y: originPoint.y,
        },
        {x: originPoint.x, y: originPoint.y - MANY_HEIGHT / 2},
      ];
    case RelationshipDecoratorType.NONE:
    default:
      return [];
  }
}
